module.exports = __webpack_public_path__ + "img/card-level.90b294b8.svg";